import { render, staticRenderFns } from "./MdlCard.vue?vue&type=template&id=fe1c623a&scoped=true"
import script from "./MdlCard.vue?vue&type=script&lang=js"
export * from "./MdlCard.vue?vue&type=script&lang=js"
import style0 from "./MdlCard.vue?vue&type=style&index=0&id=fe1c623a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1c623a",
  null
  
)

export default component.exports